module.exports = __webpack_public_path__ + "static/media/Politicas-SIG-V05.897d88a4.png";